import { Notification } from "../components/Notification/Notification"

export const NotificationPage=()=>{
    return <Notification/>
}